// Copyright (c) 2026 Aravind Adari. All rights reserved.

import { useEffect, useState } from "react";
import { getIdTokenResult } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";

export default function DashboardPage() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function redirect() {
      const user = auth.currentUser;
      if (!user) {
        navigate("/login");
        return;
      }
      const idTokenResult = await getIdTokenResult(user, true);
      const claims = idTokenResult.claims as Record<string, unknown>;
      const platformRole = (claims.platformRole as string) ?? "";
      const role = (claims.role as string) ?? "";

      if (platformRole === "super_admin") {
        navigate("/platform");
        return;
      }
      switch (role) {
        case "receptionist":
          navigate("/timesheet");
          break;
        case "manager":
          navigate("/payroll");
          break;
        case "admin":
          navigate("/admin");
          break;
        default:
          navigate("/login");
          break;
      }
      setLoading(false);
    }
    redirect();
  }, [navigate]);

  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Redirecting...</Typography>
      </Box>
    );

  return null;
}
